// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-0d0fdd7c","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/create-campaign/chat-panel/ChatPanel.css
// module id = wgXm
// module chunks = 1